import React, { useEffect } from 'react';

import { Box } from '@ublend-npm/aulaui-core';

import useBreakpoints from '@app/hooks/useBreakpoints';
import { useFlags } from 'launchdarkly-react-client-sdk';
import pushRoute from '@app/utils/routing';
import { useSelector } from 'react-redux';
import { getCurrentSpaceId } from '@core/selectors/space';
import ParticipantHistory from './ParticipantHistory';
import NavigationBackHeader from '@app/components/presentational/common/NavigationBackHeader/NavigationBackHeader';
import { goToParticipantsWithBackButton } from '@core/constants/backButtonNavigation';
import StaffOnlyAlert from '@app/components/presentational/common/StaffOnlyAlert/StaffOnlyAlert';

const ParticipantHistoryScreen = () => {
  const { md } = useBreakpoints();

  const spaceId = useSelector(getCurrentSpaceId);

  // Participants History should be a whole page if the screen width is md or
  // smaller and a drawer if the screen width is md or larger
  useEffect(() => {
    if (md) {
      pushRoute(
        `/dashboard/${spaceId}/people/participants?open=participant-history`
      );
    }
  }, [md]);

  // Users can not access this screen if the feature flag is disabled
  const { webAppFtResponsiveParticipants202601 } = useFlags();
  if (!webAppFtResponsiveParticipants202601) {
    pushRoute('/dashboard');
  }

  return (
    <Box>
      <StaffOnlyAlert />
      <NavigationBackHeader
        wrapperStyle={{ m: 2, mb: 0 }}
        route={goToParticipantsWithBackButton(spaceId)}
      />
      <Box sx={{ m: 3, mt: 1.25 }}>
        <ParticipantHistory />
      </Box>
    </Box>
  );
};

export default ParticipantHistoryScreen;
